import APIClient from '@/shared/http/clients/api'

const resourceName = 'authorize'
const APICore = process.env.APIBaseURLCore

const SignIn = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}`, data, {...config, withCredentials: true})
const SignOut = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/signOut`, data, config)
const SSO = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/security-token`, data, config)
const ResetEmailSenha = (data, config = {}) => APIClient.post(`${APICore}/${resourceName}/ResetEmailSenha`, data, config)

// Logout — expira o cookie zcloud_token no servidor (usado em prod/aceite)
const Logout = (config = {}) => APIClient.post(`${APICore}/${resourceName}/logout`, {}, config)

// Me — retorna dados do usuário autenticado via cookie (usado em prod/aceite no reload)
// Retorno esperado: { code: 200, data: { ContaID, Name, Email } }
const Me = (config = {}) => APIClient.get(`${APICore}/${resourceName}/me`, config)

const AuthRepository = {
  SignIn,
  SignOut,
  SSO,
  ResetEmailSenha,
  Logout,
  Me
}

export default AuthRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/auth.js